<template lang='pug'>
div(:class='$style[`cc-aisolution`]')
  //- div(v-if='!isVip' :class='$style[`cc-aisolution-result`]')
  //-   div(:class='$style[`cc-aisolution-goshop`]')
      //- router-link.btn-extra.font-medium(
      //-   v-if='loginStatus'
      //-   role='button'
      //-   tabindex='0'
      //-   aria-label='立即訂閱'
      //-   to='/shop/subscribe'
      //-   :class='$style[`cc-aisolution-goshop-shop`]') 立即訂閱
      //- button.btn-extra.font-medium(v-else tabindex='0' aria-label='請先登入 / 註冊' :class='$style[`cc-aisolution-goshop-shop`]' @click='handleClickLogin') 請先登入 / 註冊

  //- div.font-medium(v-else :class='$style[`cc-aisolution-result-progress`]')
  //-   StepProgress(
  //-     :steps='processSteps'
  //-     :current-step='currentStep'
  //-     :active-color='`#009FA5`'
  //-     :passive-color='`#eee`'
  //-     :active-thickness='6'
  //-     :passive-thickness='6'
  //-     :line-thickness='6'
  //-     icon-class='fa fa-check')

  div(:class='$style[`cc-aisolution-result`]')
    div(v-if='showLoading' :class='$style[`cc-aisolution-result-block`]')
      div(:class='$style[`cc-aisolution-result-block-loading`]')
        IconLoading(:size='36' :color='`#b1b1b1`')

    div(v-else :class='$style[`cc-aisolution-result-block`]')
      //- header.font-medium(:class='$style[`cc-aisolution-result-title`]') 挑選與您相似症狀
      template(v-if='isEmpty')
        div(:class='$style[`cc-aisolution-result-empty`]')
          span 查無資料

      template(v-else)
        //- STEP-1 選擇符合症狀
        div(v-if='currentStep === 0 && isVip' :class='$style[`cc-aisolution-result-wrap`]')
          ul(:class='$style[`cc-aisolution-result-condition`]')
            li(
              v-for='items, index in searchResult'
              :key='index'
              :class='$style[`cc-aisolution-result-condition-li`]')
              button.btn-extra(
                tabindex='0'
                :title='`選擇${items.relative}`'
                :aria-label='`選擇${items.relative}`'
                @click='switchAiDoctorFeedBack(items)') {{ items.relative }}

          div(v-if='showLoadMoreLoading' :class='$style[`cc-aisolution-result-load-more`]')
            IconLoading(:size='36' :color='`#b1b1b1`')
          div(v-show='showLoadMore' :class='$style[`cc-aisolution-result-loader`]')
            button.btn-black-extra(
              :class='$style[`cc-aisolution-result-loader-btn`]'
              tabindex='0'
              aria-label='看更多症狀'
              title='看更多症狀'
              @click='clickLoadMoreQuestion') 看更多症狀


        div(v-else-if='currentStep === 0 && !isVip' :class='$style[`cc-aisolution-result-wrap`]')
          ul(v-if='searchResult.length' :class='$style[`cc-aisolution-result-condition`]')
            li(
              v-for='items, index in searchResult'
              :key='index'
              :class='$style[`cc-aisolution-result-condition-li`]')
              button.btn-extra(
                tabindex='0'
                :title='`選擇${items.relative}`'
                :aria-label='`選擇${items.relative}`'
                @click='switchAiDoctorFeedBack(items)') {{ items.relative }}
            li(
              v-for='n in 2'
              :class='$style[`cc-aisolution-result-condition-li`]')
              div(:class='$style[`cc-locked-panel`]')
                IconLocker(:size='20' :color='`#999`')
                span 請先訂閱以瀏覽更多內容



        //- STEP-2 詢問狀況
        div(v-if='currentStep === 1' :class='$style[`cc-aisolution-result-wrap`]')
          div(:class='$style[`cc-aisolution-result-patient`]')
            figure.font-medium(:class='$style[`cc-aisolution-result-patient-avatar`]') 我

            div(:class='$style[`cc-aisolution-result-patient-dialog`]')
              span(:class='$style[`cc-aisolution-result-patient-dialog-say`]') 詢問狀況: 
              span(:class='$style[`cc-aisolution-result-patient-dialog-ans`]' v-html='myQues')

          div(:class='$style[`cc-aisolution-result-doctor`]')
            figure(:class='$style[`cc-aisolution-result-doctor-avatar`]')
              img(
                :src='`${STATIC_URL}images/drcell/avatar.webp`'
                width='100%'
                height='100%')

            div(v-show='!showDialog' :class='$style[`cc-aisolution-result-doctor-reading`]')
              ul(:class='$style[`cc-aisolution-result-doctor-reading-dot`]')
                li(v-for='n in 3')

            transition(name='ani-slide-left-fade')
              div(v-show='showDialog' :class='$style[`cc-aisolution-result-doctor-dialog`]')
                div(v-if='showEvaluate' :class='$style[`cc-aisolution-result-evaluate`]')
                  button.btn-extra(:class='$style[`cc-aisolution-result-evaluate-good`]' tabindex='0' aria-label='有用' @click='sendEvaluateForAnswer(myQues, `good`)')
                    IconConfirm(:size='22' :color='`#81e0a9`')
                    span 有用
                  button.btn-extra(:class='$style[`cc-aisolution-result-evaluate-bad`]' tabindex='0' aria-label='沒幫助' @click='sendEvaluateForAnswer(myQues, `bad`)')
                    IconDelete(:size='22' :color='`#d8374d`')
                    span 沒幫助

                span(:class='$style[`cc-aisolution-result-doctor-dialog-say`]') Dr.Cell AI醫生：
                span(:class='$style[`cc-aisolution-result-doctor-dialog-ans`]' v-html='aiFeedBack')

                //- 推薦閱讀
                div(v-if='crawler.length' :class='$style[`cc-aisolution-article-crawler`]')
                  header.font-medium(:class='$style[`cc-aisolution-article-head`]') 推薦閱讀
                  a(v-for='items, index in crawler' :class='$style[`cc-aisolution-result-doctor-crawl`]' :href='items.link')
                    div(:class='$style[`cc-aisolution-result-crawl-left`]')
                      figure(v-if='items.domain === `cancell.tw`' :class='$style[`cc-aisolution-result-crawl-thumb`]')
                        img(:src='`${STATIC_URL}cancell.png`' width='100%')
                      figure(v-else :class='$style[`cc-aisolution-result-crawl-thumb`]')
                        img(:src='items.thumbSrc' width='100%')
                      div(:class='$style[`cc-aisolution-result-crawl-content`]')
                        span(:class='$style[`cc-aisolution-result-crawl-content-domain`]') {{ items.domain }}
                        span.font-medium(:class='$style[`cc-aisolution-result-crawl-content-title`]') {{ items.title }}
                    div(:class='$style[`cc-aisolution-result-crawl-right`]')
                      span 點擊閱讀


                //- 推薦課程
                //- div(v-if='podcast.length' :class='$style[`cc-aisolution-article-crawler`]')
                //-   header.font-medium(:class='$style[`cc-aisolution-article-head`]') 推薦課程與媒體
                //-   div(v-for='items, index in podcastLimitLoad' :class='$style[`cc-aisolution-result-doctor-crawl`]')
                //-     iframe(
                //-       allow='autoplay *; encrypted-media *; fullscreen *; clipboard-write'
                //-       frameborder='0'
                //-       height='175'
                //-       style='width:100%;max-width:100%;overflow:hidden;background:transparent;'
                //-       sandbox='allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation'
                //-       :src='items.link')
                //-   button(
                //-     v-if='showPodcastLoadMore'
                //-     :class='$style[`cc-aisolution-result-doctor-load-podcast`]'
                //-     tabindex='0'
                //-     aria-label='看更多'
                //-     @click='clickLoadMorePodcast') 看更多課程 / 媒體
                
                div(v-if='shopStuff.length' :class='$style[`cc-aisolution-shop-stuff`]')
                  button.btn-extra(tabindex='0' aria-label='上一個' :class='[`swiper-button-prev`, $style[`cc-aisolution-shop-stuff-controll-prev`]]') ←
                  button.btn-extra(tabindex='0' aria-label='下一個' :class='[`swiper-button-next`, $style[`cc-aisolution-shop-stuff-controll-next`]]') →

                  div(v-swiper:upgradeSwiper='swiperOption' :class='$style[`cc-aisolution-shop-stuff-wrap`]')
                    header.font-medium(:class='$style[`cc-aisolution-shop-stuff-head`]') 您感興趣的保健品

                    ul(:class='[`swiper-wrapper`, $style[`cc-aisolution-shop-stuff-ul`]]')
                      li(v-for='items, index in shopStuff' :key='index' :class='[`swiper-slide`, $style[`cc-aisolution-shop-stuff-li`]]' :title='items.mallTitle')
                        router-link(
                          role='button'
                          tabindex='0'
                          aria-label='了解更多'
                          :to='`/shop/stuff/${items.stuff_id}`'
                          :class='$style[`cc-aisolution-shop-stuff-wrap`]')
                          div(:class='$style[`cc-aisolution-shop-stuff-main`]')
                            span(:class='$style[`cc-aisolution-shop-stuff-tag`]') {{ items.mallFoodType }}
                            figure(:class='$style[`cc-aisolution-shop-stuff-thumb`]')
                              img(:src='items.mallSrc[0]' width='100%' loading='lazy')
                            div.font-medium(:class='$style[`cc-aisolution-shop-stuff-title`]') {{ items.mallTitle }}


          //- 返回
          div(v-show='showDialog' :class='$style[`cc-aisolution-result-controll`]')
            button.btn-black-extra(
              tabindex='0'
              aria-label='返回症狀列表'
              :class='$style[`cc-aisolution-result-controll-btn`]'
              @click='switchProgressBack') 返回症狀列表

            router-link(
              tabindex='0'
              aria-label='線上諮詢專家'
              to='/sideeffect/consult'
              :class='$style[`cc-aisolution-result-controll-ask`]') 線上諮詢專家


</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { directive } from 'vue-awesome-swiper';
import {
  putSendEvaluate,
  putAiDoctorSearch,
  // putAiSearchBarResults,
  getCrawlContentByLink,
} from '../../../js/restapi';

import IconLoading from '../../icon/Loading';
import IconConfirm from '../../icon/Confirm';
import IconDelete from '../../icon/Delete';
import IconLocker from '../../icon/Locker';

export default {
  components: {
    IconLoading,
    IconConfirm,
    IconDelete,
    IconLocker,
  },

  directives: {
    swiper: directive,
  },

  props: {
    searchValue: {
      type: String,
      default: '',
    },
    isVip: {
      type: Boolean,
      default: true,
    },
    redirectRouter: {
      type: String,
      default: 'error404',
    },
    bpDesktop: {
      type: Number,
      default: 4,
    },
    bpTablet: {
      type: Number,
      default: 3,
    },
    bpMobile: {
      type: Number,
      default: 2,
    },
  },

  data() {
    return {
      isEmpty: false,
      showLoading: true,
      showDialog: true,
      showLoadMore: true,
      showLoadMoreLoading: false,
      showEvaluate: true,

      currentStep: 0,
      // processSteps: ['選擇相似症狀', 'Ai醫生回答'],
      
      aiFeedBack: '嗨！很高興為您服務。請由上方點擊選擇與您目前的症狀較符合的提問，我才能給你最好的諮詢建議喔。',
      // aiSubscribeType: '',
      // aiSubscribeTeam: '',
      myQues: '',

      crawler: [],
      // podcast: [],
      // podcastMaxLen: 2,
      // showPodcastLoadMore: true,
      shopStuff: [],
      searchResult: [],

      pageSize: 8,
      pageIndex: 1,

      swiperOption: {
        spaceBetween: 10,
        threshold: 20,
        slidesPerView: 4,
        slidesPerGroup: 4,
        loop: false,
        loopFillGroupWithBlank: true,
        edgeSwipeThreshold: 100,
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true,
        // },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          1280: {
            spaceBetween: 10,
            slidesPerView: this.bpDesktop,
            slidesPerGroup: this.bpDesktop,
          },
          960: {
            spaceBetween: 10,
            slidesPerView: this.bpDesktop,
            slidesPerGroup: this.bpDesktop,
          },
          731: {
            spaceBetween: 10,
            slidesPerView: this.bpTablet,
            slidesPerGroup: this.bpTablet,
          },
          500: {
            spaceBetween: 10,
            slidesPerView: this.bpTablet,
            slidesPerGroup: this.bpTablet,
          },
          370: {
            spaceBetween: 10,
            slidesPerView: this.bpMobile,
            slidesPerGroup: this.bpMobile,
          },
          0: {
            spaceBetween: 10,
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
        },
      },
    };
  },

  created() {
    this.axiosLoadAiDoctorSearch();
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    // initPageOnLoad() {
      // if (!this.$route.query.q) {
      //   this.$router.replace({
      //     name: this.redirectRouter,
      //   }).catch(()=>{});
      // } else {
      //   if (this.showLoading) {
      //     this.showLoading = false;
      //   }
      //   console.log('initPageOnLoad');
      //   this.initUserVipValidProcess();
      // }
    //   this.initUserVipValidProcess();
    // },

    // initPageOnLoad() {
      // if (this.isVip) {
      //   this.showLoading = true;
      //   this.axiosLoadAiDoctorSearch(this.searchValue);
      // } else {
      //   this.showLoading = false;
      // }

      // this.showLoading = true;
    //   this.axiosLoadAiDoctorSearch();
    // },

    // handleClickLogin() {
    //   this.changePopBoxStatus({
    //     active: true,
    //     include: 'login',
    //   });
    // },

    axiosLoadAiDoctorSearch() {
      const searchProcess = new Promise((resolve) => {
        this.pageIndex = 1;
        this.isEmpty = false;
        this.showLoadMore = true;
        this.showLoading = true;
        this.searchResult = [];
        return resolve();
      });

      searchProcess.then(() => {
        const PASS_CONFIG = {
          auth_id: `${this.loginDjangoId}`,
          service: '',
          team_id: '',
          ques: this.searchValue,
          size: this.pageSize,
          page: this.pageIndex,
        };

        putAiDoctorSearch('', PASS_CONFIG, {
          headers: {
            'content-Type': 'application/json',
            // Authorization: `Bearer ${jwtAccess}`,
          },
        })
          .then((res) => {
            if (res.data === 'invalid') {
              this.showLoadMore = false;
              this.isEmpty = true;

            } else {
              if (!res.data.count) {
                this.showLoadMore = false;
                this.isEmpty = true;
              }
    
              if (res.data.results.length < this.pageSize || this.searchResult.length === res.data.count) {
                this.showLoadMore = false;
              }
              this.searchResult = res.data.results;
            }
            this.showLoading = false;
            this.currentStep = 0;
          })
          .catch((error) => {
          });
      })
    },

    switchAiDoctorFeedBack(items) {
      this.showDialog = false;
      this.myQues = items.relative;
      this.currentStep = 1;

      if (items.href) {
        // const CRAWL_LINK = doc.querySelector('a').href;
        items.href.map(x => {
          getCrawlContentByLink(`?text=${x}`)
            .then((res) => {
              this.crawler.push({
                link: x,
                domain: res.data.domain,
                title: res.data.title,
                thumbSrc: res.data.thumbSrc,
              });
              console.log('crawler', this.crawler);
            })
            .catch((error) => {
            });
        });
      }

      // if (items.podcast) {
      //   this.podcast = items.podcast;
      // }

      if (items.stuff) {
        // const CRAWL_LINK = doc.querySelector('a').href;
        this.shopStuff = items.stuff
      }

      setTimeout(() => {
        this.showDialog = true;
        this.aiFeedBack = items.answer;
      }, 600);
    },

    switchProgressBack() {
      this.showEvaluate = true;
      this.currentStep = 0;
      // this.podcastMaxLen = 2;
      // this.showPodcastLoadMore = true;
      this.crawler = [];
    },

    sendEvaluateForAnswer(relative, evaluate) {
      const SEND_DATA = {
        relative,
        evaluate,
      };

      putSendEvaluate('', SEND_DATA)
        .then((res) => {
          console.log('res', res.data);
          this.changePopBoxStatus({
            active: true,
            include: 'sendEvaluate',
          });

          this.showEvaluate = false;

          setTimeout(() => {
            this.changePopBoxStatus({
              active: false,
              include: '',
            });
          }, this.POP_DURATION);
        })
        .catch((err) => {
          console.log('err', err.response);
        })
    },

    clickLoadMoreQuestion() {
      this.pageIndex += 1;
      this.showLoadMoreLoading = true;

      const PASS_CONFIG = {
        auth_id: `${this.loginDjangoId}`,
        // service: this.aiSubscribeType,
        // team_id: this.aiSubscribeTeam,
        service: '',
        team_id: '',
        ques: this.searchValue,
        size: this.pageSize,
        page: this.pageIndex,
      };

      putAiDoctorSearch('', PASS_CONFIG, {
        headers: {
          'content-Type': 'application/json',
          // Authorization: `Bearer ${jwtAccess}`,
        },
      })
        .then((res) => {
          console.log(res, this.searchResult);
          res.data.results.map((x) => this.searchResult.push(x));
          this.showLoadMoreLoading = false;
          if (res.data.results.length < this.pageSize || this.searchResult.length === res.data.count) {
            this.showLoadMore = false;
          }
        })
        .catch((error) => {
          this.showLoadMoreLoading = false;
        });
    },

    // clickLoadMorePodcast() {
    //   if (this.podcastMaxLen >= this.podcast.length) {
    //     return;
    //   };
    //   this.podcastMaxLen = this.podcastMaxLen + 3;
    // }
  },

  computed: {
    ...mapGetters({
      rwdType: 'global/exportRwdType',
      loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      // loginSubscribeValid: 'user/exportUserSubscribeValid',
      subscribeVip: 'user/exportUserSubscribeVip',
      // loginProfile: 'user/exportUserProfile',
      authJwtToken: 'user/exportUserJwtToken',
    }),

    // podcastLimitLoad() {
    //   if (this.podcastMaxLen >= this.podcast.length) {
    //     this.showPodcastLoadMore = false;
    //   };
    //   return this.podcast.slice(0, this.podcastMaxLen);
    // },
  },

  // watch: {
  //   loginStatus() {
  //     if (this.loginStatus) {
  //       this.initPageOnLoad();
  //     }
  //   }
  // },
};
</script>


<style module lang='scss'>
  @import '../../../sass/component/page/ai/aiSolution.scss';
</style>